import { useEffect, useRef } from 'react';

export default function usePreviousRoute(location: any) {
  const ref = useRef();
  useEffect(() => {
    (ref.current as any) = location;
  }, [location]);
  return ref.current;
}
